import { CommonModule } from '@angular/common';
import { Component, computed, inject, Signal } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HabitTimerState } from '@app/_interfaces/habit.interface';
import { ParseSecondsPipe } from '@app/_pipes/parse-seconds.pipe';
import { CacheService } from '@app/_services/cache.service';
import { HabitStore } from '@app/_stores';
import { SvgComponent } from '@app/components/shared/svg/svg.component';
import { HabitFormComponent } from '../habit-form/habit-form.component';
import { HabitTimerService } from '@app/_services/habit-timer.service';
import { SettingsService } from '@app/_services/settings.service';
import { ModalService } from '@app/_services/modal.service';

@Component({
  selector: 'app-habit-timer-dialog',
  imports: [
    CommonModule,
    SvgComponent,
    ParseSecondsPipe
  ],
  templateUrl: './habit-timer-dialog.component.html',
  styleUrl: './habit-timer-dialog.component.scss'
})

export class HabitTimerDialogComponent {

  readonly habitStore = inject(HabitStore);

  timers: Signal<any[]> = computed(() =>
    this.timerService.addedTimers().filter(timer =>
      this.habitStore.idToSetup()[timer.setupId]?.deletedAt === null
    )
  );

  constructor(
    public dialogRef: MatDialogRef<HabitTimerDialogComponent>,
    public cc: CacheService,
    private dialog: MatDialog,
    private timerService: HabitTimerService,
    public ss: SettingsService,
    private modalService: ModalService
  ) {

  }

  getPercentage(timer: HabitTimerState): number {
    const setup = this.habitStore.idToSetup()[timer.setupId];
    if (timer.totalSeconds === 0) {
      return 0;
    }
    return Math.floor((timer.totalSecondsSpent / (timer.totalSeconds * setup.roundCount)) * 100);
  }

  getTotalSeconds(timer: HabitTimerState): number {
    const setup = this.habitStore.idToSetup()[timer.setupId];
    return timer.totalSeconds * setup.roundCount;
  }

  openHabit(timer: HabitTimerState) {
    const habit = this.habitStore.habitMap().setups[timer.setupId]?.[timer.dateString] || null;
    const confirmDialog = this.modalService.openLevel1(
      HabitFormComponent,
      {
        mode: habit ? 'edit' : 'new',
        value: habit,
        setupId: timer.setupId,
        dateString: timer.dateString
      },
      { disableClose: true, autoFocus: false }
    );

    this.dialogRef.close();
  }

}
